import React, { useEffect } from "react";
import {
  RestlessTable,
  RestlessButtonFormatter,
} from "../../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import { fetchHashtagsDetails } from "../../../../redux/actions/hashtags";
import RestlessDateFormatter from "../../../../_metronic/layout/components/Table/RestlessDateFormatter";
import RestlessTypeFormatter from "../../../../_metronic/layout/components/Table/RestlessTypeFormatter";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Route } from "react-router-dom";
import PostsDetailsDialog from "../../RestlessContent/RestlessPostsDialog/PostsDetailsDialog";

export default function RestlessHashtagsDetails({
  history,
  match,
  prevPath,
  row,
}) {
  const dispatch = useDispatch();

  const { hashtagsDetailsList, listDetailsLoading } = useSelector((state) => ({
    hashtagsDetailsList: state.hashtags.hashtagsDetailsList || [],
    listDetailsLoading: state.hashtags.listDetailsLoading,
  }));

  useEffect(() => {
    dispatch(fetchHashtagsDetails(match.params.hashtag));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const interactionsFormatter = (cellContent) => {
    return (
      <div>
        {cellContent === undefined || cellContent === null ? 0 : cellContent}
      </div>
    );
  };
  const buttonsArr = [
    {
      onClickFunction: (row) => {
        return postsUIEvents.openPostsDetailsDialog(row);
      },
      icon: (
        <SVG title="Detail" src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")} />
      ),
      title: "Detail"
    },
    {
      onClickFunction: (row) => {
        return postsUIEvents.openModeratePostsDialog(row);
      },
      icon: (
        <SVG title="Moderate" src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
      ),
      title: "Moderate"
    },
  ];
  //Functions to open the dialog
  const postsUIEvents = {
    openPostsDetailsDialog: (row) => {
      history.push({
        pathname: `/hashtags/${encodeURIComponent(
          hashtagsDetailsList.hashtag
        )}/details/${row.id}`,
        state: {
          row: row,
        },
      });
    },
    openModeratePostsDialog: (row) => {
      history.push(`/posts/${row.id}/moderate`);
    },
  };
  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Author",
      sort: true,
    },
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },

    {
      dataField: "poll",
      text: "Type",
      sort: true,
      formatter: RestlessTypeFormatter,
    },
    {
      dataField: "category.name",
      text: "Category",
      sort: true,
    },
    {
      dataField: "reaction",
      text: "Reaction",
      sort: true,
      formatter: interactionsFormatter,
    },
    {
      dataField: "info.comments",
      text: "Comments",
      sort: true,
      formatter: interactionsFormatter,
    },
    {
      dataField: "reports",
      text: "Reports",
      sort: true,
      formatter: interactionsFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: {
        buttonsArr,
      },
    },
  ];
  return (
    <>
      {listDetailsLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          <Route path="/hashtags/:hastag/details/:id">
            {({ history, match }) => (
              <PostsDetailsDialog
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                onHide={() => history.goBack()}
              />
            )}
          </Route>
          <RestlessTable
            data={hashtagsDetailsList.posts || []}
            columns={columns}
            withPagination
          />
        </>
      )}
    </>
  );
}
